import api from './api';
import type { ContactFormData } from '../types';

export const contactApi = {
  submitMessage: async (formData: ContactFormData): Promise<void> => {
    await api.post('contact', { json: formData });
  },
};
